export default __webpack_public_path__ + "static/media/logo-red.e26d0876.png";